export default "__VITE_ASSET__CXaQqXQe__"